module.exports = __webpack_public_path__ + "static/media/sign_warning.1ad82fa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sign_warning.png
// module id = 319
// module chunks = 0